// src/routes/PrivateRoutes.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../components/context/AuthContext";
// 🔒 Only logged-in users can access
export const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

// 🔒 Only admins can access
export const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  return user && user.role === "admin" ? children : <Navigate to="/login" replace />;
};

// 🔒 Only resellers can access (optional)
export const ResellerRoute = ({ children }) => {
  const { user } = useAuth();
  return user && user.role === "reseller" ? children : <Navigate to="/login" replace />;
};
